export default __webpack_public_path__ + "static/media/redteaming.39104d45.png";